<table class="table table-striped text-dark-m1">
  <thead>
    <!-- <tr class="bgc-primary-tp2 text-white">
      <th>
      </th>
      <th>
      </th>
      <th>
      </th>
      <th>
      </th>
    </tr> -->
  </thead>
  <tbody>
    <tr style="background-color: white">

      <td >
          <div class="form-element"
            [ngClass]="{ 'error': form.elements['assessmentAreaId'].error.required || form.elements['assessmentAreaId'].error.invalid }">
            <!-- <label>{{ translationManager.getTranslation('Област оцењивања') }}</label> -->
            <div class="content" *ngIf="state === viewState.Details || state === viewState.Edit">
              <select [(ngModel)]="form.elements['assessmentAreaId'].value"
                (change)="changeAssessmentArea($event.target.value)">
                <option></option>
                <option *ngFor="let item of assessmentAreas" [value]="item.id">
                  {{ translationManager.getTranslation('AssessmentArea-Name#' + item.id) }}
                </option>
              </select>
            </div>
            <div class="errors">
              <span *ngIf="form.elements['assessmentAreaId'].error.required">
                <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос')
                }}</span>
            </div>
          </div>
        </td>

        <td>
          <div class="form-element"
            [ngClass]="{ 'error': form.elements['description'].error.required || form.elements['description'].error.invalid }">
            <!-- <label>{{ translationManager.getTranslation('Опис') }}</label> -->
            <div class="content" *ngIf="state === viewState.Details || state === viewState.Edit">
              <textarea class="form-element" [(ngModel)]="form.elements['description'].value"></textarea>
            </div>
            <div class="errors">
              <span *ngIf="form.elements['description'].error.required">
                <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос')
                }}</span>
            </div>
          </div>
        </td>

        <td>
          <div class="form-element"
            [ngClass]="{ 'error': form.elements['points'].error.required || form.elements['points'].error.invalid }">
            <!-- <label>{{ translationManager.getTranslation('Бодови') }}</label> -->
            <div class="content" *ngIf="state === viewState.Details || state === viewState.Edit">
              <input type="number" [(ngModel)]="form.elements['points'].value"
                (keydown)="checkNumberKeyDown($event, form.elements['points'].value)">
            </div>
            <div class="errors">
              <span *ngIf="form.elements['points'].error.required">
                <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос')
                }}</span>
            </div>
          </div>
        </td>

        <td class="right" style="width:5%">
          <div class="actions">
            <div>
              <a href="javascript:;" [title]="translationManager.getTranslation('Обриши елемент')" (click)="delete()"><i
                  class="far fa-trash-alt tc-red right"></i></a>
            </div>
          </div>
        </td>

      </tr>


  </tbody>
</table>
